import React, { FormEvent } from 'react';
import {
  FormBuilder, Validators, FieldGroup, FieldControl
} from 'react-reactive-form';
import { RouteComponentProps } from 'react-router';
import { TextInput } from '../../../components/forms/Input';
import logo from '../../../assets/img/RateChain-logo.svg';
import api from '../../../api/authentication/authentication.client';

interface ForgotPasswordState {
  requestSent: boolean;
}

export default class ForgotPassword extends React.PureComponent<RouteComponentProps, ForgotPasswordState> {

  readonly state = {
    requestSent: false
  };

  form = FormBuilder.group({
    username: [ '', Validators.required ],
  });

  onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (this.form.valid) {
      api.password.requestPasswordReset(this.form.value.username).then(() => {
        this.setState({ requestSent: true });
      });
    }
  };

  render() {
    return (
      <>
        <main>
          <div className="login-container col-4 offset-4">
            <div className="col-8 offset-2 mb-1">
              <img className="login-image" alt="Rate-chain" src={logo} />
            </div>
            { !this.state.requestSent ? (
              <FieldGroup
                control={this.form}
                render={() => (
                  <form className="mt-4" onSubmit={this.onSubmit}>
                    <div className="form-row">
                      <div className="col-8 offset-2">
                        <label>Username / Email</label>
                        <FieldControl
                          name="username"
                          render={TextInput}
                        />
                      </div>
                    </div>
                    <div className="form-row mt-2">
                      <div className="col-8 offset-2">
                        <button name="continue" type="submit" className="btn btn-primary btn-full-size" disabled={!this.form.valid}>CONTINUE</button>
                        <button onClick={() => this.props.history.push('/login')} name="cancel" type="submit" className="btn btn-outline-secondary btn-full-size mt-1">CANCEL</button>
                      </div>
                    </div>
                  </form>
                )}
              />
            ) : (
              <>
                <div className="col-8 offset-2 mt-3">
                  <div>{`Password reset requested for user ${this.form.value.username},`}</div>
                  <div>please check your email</div>
                </div>
                <div className="col-8 offset-2 mt-1">
                  <button onClick={() => this.props.history.push('/login')} name="cancel" type="submit" className="btn btn-outline-secondary btn-full-size mt-1">BACK TO LOGIN</button>
                </div>
              </>
            )}
          </div>
        </main>
      </>
    );
  }
}
